import { ApolloError, useQuery } from '@apollo/client';

import {
  PayrollQreFragment,
  SEARCH_FOR_POTENTIAL_COMPANY_OFFICERS,
  SearchForPotentialCompanyOfficersQuery,
  SearchForPotentialCompanyOfficersQueryVariables,
} from '@neo.tax/shared';

export const useSearchForPotentialCompanyOfficers = (
  fiscalYearId: string,
  searchTerm: string,
): {
  payrollQres: PayrollQreFragment[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data, error, loading } = useQuery<
    SearchForPotentialCompanyOfficersQuery,
    SearchForPotentialCompanyOfficersQueryVariables
  >(SEARCH_FOR_POTENTIAL_COMPANY_OFFICERS, {
    variables: {
      fiscalYearId,
      searchTerm,
    },
    context: {
      errorToast: {
        title: 'Error searching company officers',
        description: 'Please try again.',
      },
    },
  });

  return {
    payrollQres: data?.searchForPotentialCompanyOfficers ?? [],
    loading,
    error,
  };
};
